import ApiService from "@/services/api.service";
import { tPresets, Presets, tPreset, ISavePresetParams, Preset } from "@/models/presets";

const api = new ApiService();

class PresetsApi {
  public async statistics(): Promise<Presets> {
    return await api.get(`/presets/statistics`, { tModel: tPresets });
  }

  public async create(params: ISavePresetParams): Promise<Presets> {
    return await api.post("/presets", params, {
      showErrors: true,
      resultKeyOnSuccess: "data",
      tModel: tPreset,
    });
  }

  public async update(params: ISavePresetParams): Promise<Preset> {
    return await api.put(`/presets/${params.id}`, params, {
      withLoader: false,
      showErrors: true,
      resultKeyOnSuccess: "data",
      tModel: tPreset,
    });
  }

  public async delete(id: number): Promise<Presets> {
    return await api.delete(`/presets/${id}`, {
      withLoader: false,
      withAxiosResponseOnSuccess: true,
    });
  }
}

export default new PresetsApi();
